<template>
    <BaseButton theme="neutral" class="flex items-center gap-3 w-full min-w-0 whitespace-normal" :title="t('components.schedule.editTrigger')">
        <i class="bi bi-calendar icon-bold" aria-hidden="true"></i>
        <span class="grow">{{ t("components.schedule.dateTime", { month: date.month, day: date.day, time: date.time }) }}</span>
        <i :class="scheduled ? 'bi bi-pen' : 'bi bi-arrow-right'" class="icon-bold" aria-hidden="true"></i>
    </BaseButton>
</template>

<script setup>
import BaseButton from "~vue/components/BaseButton.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps({
    // Luxon date object
    date: {
        type: Object,
        default: () => ({}),
    },
    scheduled: {
        type: Boolean,
        default: false,
    },
});
</script>
